import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found — Razor Build" description="The page you're looking for doesn't exist." />
      <div className="pt-44 pb-32 min-h-[70vh] bg-paper">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <img src="/logo-mark-black.png" alt="" className="w-14 mx-auto opacity-30 mb-8" />
          <h1 className="font-display font-bold text-5xl md:text-7xl text-ink display-expanded">404</h1>
          <p className="mt-4 text-slate2">The page you're looking for doesn't exist or has moved.</p>
          <Link to="/" data-testid="notfound-home-link" className="mt-8 inline-block bg-ink text-white font-mono text-[11px] tracking-[0.18em] uppercase px-6 py-4 hover:bg-charcoal transition-colors">
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
}
